import { render, staticRenderFns } from "./IconNavItem.vue?vue&type=template&id=198cdb35&scoped=true&"
import script from "./IconNavItem.vue?vue&type=script&lang=js&"
export * from "./IconNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198cdb35",
  null
  
)

export default component.exports